module.exports = __webpack_public_path__ + "static/img/b303.b85fd21e.png";